import { Github } from "lucide-react";

type SocialProvider = "google" | "github";

type Props = {
  provider: SocialProvider;
  className?: string;
};

export function SocialProviderIcon({ provider, className }: Props) {
  if (provider === "github") {
    return <Github className={className} aria-hidden="true" />;
  }

  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path
        d="M21.35 11.1h-9.18v2.92h5.27c-.23 1.5-1.12 2.76-2.39 3.61v2.99h3.86c2.26-2.08 3.56-5.17 3.56-8.82 0-.8-.07-1.57-.21-2.3Z"
        fill="#4285F4"
      />
      <path
        d="M12.17 22.62c3.24 0 5.95-1.08 7.93-2.92l-3.86-2.99c-1.08.72-2.45 1.15-4.07 1.15-3.13 0-5.78-2.12-6.72-4.96H1.46v3.09a11.97 11.97 0 0 0 10.71 6.63Z"
        fill="#34A853"
      />
      <path
        d="M5.45 12.9a7.2 7.2 0 0 1 0-4.58V5.23H1.46a11.98 11.98 0 0 0 0 10.76l3.99-3.09Z"
        fill="#FBBC05"
      />
      <path
        d="M12.17 7.36c1.76 0 3.35.61 4.59 1.79l3.43-3.44C18.11 3.78 15.4 2.62 12.17 2.62 7.45 2.62 3.36 5.34 1.46 9.23l3.99 3.09c.94-2.84 3.59-4.96 6.72-4.96Z"
        fill="#EA4335"
      />
    </svg>
  );
}
